import { call, put, takeLatest } from "redux-saga/effects";
import { monHocApi } from "../../../api/category/monHocApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { actions } from "../../actions";
import { eMonHocActionTypeIds } from "../../action-types/category/IMonHocActionType";

export function* monHocSaga(): any {
    yield takeLatest(eMonHocActionTypeIds.LOAD_START, loadWorker)
}
function* loadWorker(): any {
    const res: IBaseRespone = yield call(monHocApi.getAll)
    if (res.is_success) {
        yield put(actions.monHoc.loadSuccess(res.data))
    } else {
        yield put(actions.monHoc.loadError(res.message))
    }
}